import { chakra } from '@chakra-ui/react';

export const ProductLogoImage = chakra('img', {
    label: 'ProductLogoImage',
    baseStyle: { w: '88px' }
});
